<template>
  <div>
    <el-tooltip  placement="top-start" effect="light">
      <div slot="content">{{row}}</div>
      <span style="cursor: default" v-if="!path">{{row}}</span>
      <router-link  :to="{path:path,query:query}" v-else class="link">{{row}}</router-link>
    </el-tooltip>
    <!--<el-tooltip v-else-if="type==2" placement="top" effect="light">-->
      <!--<div slot="content">{{row.title}}</div>-->
      <!--<router-link  :to="{path:'/content/detail',query:{id:row.id}}" class="link">{{row.title}}</router-link>-->
    <!--</el-tooltip>-->
  </div>
</template>
<script>
  export default {
    //type 1-代表最简单的，传什么就什么
    // type 2--链接型
    props: {
      'row': {},
      'path':{},
      'query':{}
    },
    name: 'popShow'
  }
</script>

<style scoped>
  .link{
    color: #458EF5;
    text-decoration: underline;
  }
</style>

